import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const Container = styled.div`
:not(:last-child){
    margin-bottom: 50px;
}
@media screen and (max-width:768px) {
    :not(:last-child){
    margin-bottom: 0px;
}
}
`

const Title = styled.p`
    position:relative;
    font-size: 20px;
    padding:0 0 20px;
    font-weight:600;
    @media screen and (max-width:768px) {
        padding:10px 0 5px 5px;
    }
`
const ViewMore = styled(Link)`
    font-size:15px;
    font-weight:400;
    color:tomato;
    margin-left:30px;
    padding: 0px 10px 2px;
    border:2px solid tomato;
    border-radius:5px;
    transition:0.2s all;
    &:hover{
        color:white;
    }
    @media screen and (max-width:768px) {
        display:block;
        align-items:center;
        position:absolute;
        padding:2px 5px;
        bottom:2px;
        right:5px;
        color:#F5C518;
        border:1px solid tomato;
    }

`

const Grid = styled.div`
    margin-top:10px;
    display:flex;   
    overflow: auto;
    width:100%;
    height:100%;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        background:rgba(0,0,0,0.1)
    }
    &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255,255,255,0.5);
    }
    @media screen and (max-width:768px) {
        width:100%;
        margin-top:10px;
        display:flex;
        overflow-x:auto
}
    
`

const Section = ({ title, children, section, term }) => {

    return (
        <Container>
            <Title>{title}<ViewMore to={section} >View More</ViewMore></Title>
            <Grid>{children}</Grid>
        </Container>
    )
}

Section.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any
}

export default Section